import { QuickMenuProps, AdaptedQuickMenuProps } from './QuickMenu.types';

/**
 * 속성 변환 함수
 * 에디터에서 전달된 props를 컴포넌트에서 사용할 수 있는 형태로 변환
 */
export function adaptQuickMenuProps(props: QuickMenuProps): AdaptedQuickMenuProps {
  const { id, style = {}, className = '', componentProps = {} } = props;
  
  // 기본값 설정
  const defaultProps = {
    categoryItems: [],
    columnsPerRow: 8, // 기본적으로 한 줄에 8개
    showCategoryName: true,
    showAllCategory: true, // 기본적으로 전체 카테고리 표시
    allCategoryGradientStart: '#667eea', // 기본 그라데이션 시작색 (보라빛 파랑)
    allCategoryGradientEnd: '#764ba2', // 기본 그라데이션 끝색 (보라색)
    allCategoryTextColor: '#ffffff', // 기본 텍스트 색상 (흰색)
    imageSize: 80, // 80px
    gap: 16, // 16px
    hoverEffect: true
  };
  
  // 어댑터 결과 생성
  const adaptedProps: AdaptedQuickMenuProps = {
    id,
    style,
    className,
    data: {
      categoryItems: componentProps.categoryItems || defaultProps.categoryItems,
      columnsPerRow: componentProps.columnsPerRow || defaultProps.columnsPerRow,
      showCategoryName: componentProps.showCategoryName !== undefined 
        ? componentProps.showCategoryName 
        : defaultProps.showCategoryName,
      showAllCategory: componentProps.showAllCategory !== undefined
        ? componentProps.showAllCategory
        : defaultProps.showAllCategory,
      allCategoryGradientStart: componentProps.allCategoryGradientStart || defaultProps.allCategoryGradientStart,
      allCategoryGradientEnd: componentProps.allCategoryGradientEnd || defaultProps.allCategoryGradientEnd,
      allCategoryTextColor: componentProps.allCategoryTextColor || defaultProps.allCategoryTextColor,
      imageSize: componentProps.imageSize || defaultProps.imageSize,
      gap: componentProps.gap || defaultProps.gap,
      hoverEffect: componentProps.hoverEffect !== undefined 
        ? componentProps.hoverEffect 
        : defaultProps.hoverEffect
    }
  };
  
  return adaptedProps;
}